import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BrandShowcase from "@/components/BrandShowcase";
import MarqueeStrip from "@/components/MarqueeStrip";
import About from "@/components/About";
import Services from "@/components/Services";
import VivriersSection from "@/components/VivriersSection";
import Gallery from "@/components/Gallery";
import WhyChooseUs from "@/components/WhyChooseUs";
import Team from "@/components/Team";
import LegalInfo from "@/components/LegalInfo";
import CTABanner from "@/components/CTABanner";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import RevealOnScroll from "@/components/RevealOnScroll";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="bg-white text-[#1F2937]">
      <Navbar />
      <main>
        <Hero />
        <BrandShowcase />
        <MarqueeStrip />
        <RevealOnScroll><About /></RevealOnScroll>
        <RevealOnScroll><Services /></RevealOnScroll>
        <RevealOnScroll><VivriersSection /></RevealOnScroll>
        <RevealOnScroll><Gallery /></RevealOnScroll>
        <WhyChooseUs />
        <RevealOnScroll><Team /></RevealOnScroll>
        <RevealOnScroll><LegalInfo /></RevealOnScroll>
        <RevealOnScroll><CTABanner /></RevealOnScroll>
        <RevealOnScroll><Contact /></RevealOnScroll>
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
